import { ReactNode } from 'react';
interface FormStepProps {
  children: ReactNode;
  validationSchema: Record<string, any>;
  onSubmit: () => void;
}

const FormStep: React.FC<FormStepProps> = ({ children }) => children;

export default FormStep;